import CloseIcon from '@/assets/icons/CloseIcon';
import { BasicContainer } from '@/components/Common/BasicContainer/BasicContainer';
import FormItem from '@/components/Common/FormItem/FormItem';
import COLORS from '@/constants/colors';
import {
  Button,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import { useAddSellerDialogViewController } from './AddSellerDialogViewController';

export function AddSeller(props: { handleClose: () => void }) {
  const { uiState, actions } = useAddSellerDialogViewController(
    props.handleClose
  );

  return (
    <>
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          background: COLORS.gray_50,
          alignItems: 'center',
        }}
      >
        <Stack>
          <Typography
            sx={{
              fontSize: '18px',
              fontWeight: 600,
              color: COLORS.gray_600,
            }}
          >
            Agregar Vendedor
          </Typography>
        </Stack>
        <IconButton onClick={props.handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ background: COLORS.gray_50 }}>
        <Stack spacing={'16px'}>
          <BasicContainer
            content={
              <Grid container columnSpacing={'20px'} p={'16px'}>
                <Grid size={12}>
                  <FormItem
                    label="Nombre del negocio"
                    helperText={uiState.businessNameError}
                  >
                    <OutlinedInput
                      fullWidth
                      value={uiState.businessName}
                      onChange={(e) =>
                        actions.onChangedBusinessName(e.target.value)
                      }
                      error={!!uiState.businessNameError}
                    />
                  </FormItem>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                  <FormItem
                    label="Nombre Completo del Responsable"
                    helperText={uiState.responsibleNameError}
                  >
                    <OutlinedInput
                      fullWidth
                      value={uiState.responsibleName}
                      onChange={(e) =>
                        actions.onChangedResponsiblename(e.target.value)
                      }
                      error={!!uiState.responsibleNameError}
                    />
                  </FormItem>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                  <FormItem label="RFC" helperText={uiState.rfcError}>
                    <OutlinedInput
                      fullWidth
                      onChange={(e) => actions.onChangedRfc(e.target.value)}
                      value={uiState.rfc}
                      error={!!uiState.rfcError}
                    />
                  </FormItem>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                  <FormItem
                    label="Régimen Fiscal"
                    helperText={uiState.fiscalRegimeError}
                  >
                    <Select
                      fullWidth
                      value={uiState.fiscalRegime}
                      onChange={actions.onChangedFiscalRegime}
                    >
                      {uiState.fiscalRegimeOptions.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormItem>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                  <FormItem
                    label="Nombre Legal"
                    helperText={uiState.legalNameError}
                  >
                    <OutlinedInput
                      fullWidth
                      onChange={(e) =>
                        actions.onChangedLegalName(e.target.value)
                      }
                      value={uiState.legalName}
                      error={!!uiState.legalNameError}
                    />
                  </FormItem>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                  <FormItem
                    label="Número de teléfono"
                    helperText={uiState.phoneNumberError}
                  >
                    <OutlinedInput
                      fullWidth
                      onChange={(e) => actions.onChangedPhone(e.target.value)}
                      value={uiState.phoneNumber}
                      error={!!uiState.phoneNumberError}
                    />
                  </FormItem>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                  <FormItem
                    label="Mínimo de compra"
                    helperText={uiState.purchaseMinAmountError}
                  >
                    <OutlinedInput
                      fullWidth
                      onChange={(e) =>
                        actions.onChangedPurchaseMinAmount(e.target.value)
                      }
                      value={uiState.purchaseMinAmount}
                      error={!!uiState.purchaseMinAmountError}
                    />
                  </FormItem>
                </Grid>
              </Grid>
            }
          />
          <BasicContainer
            content={
              <Grid container columnSpacing={'20px'} p={'16px'}>
                <Grid size={{ xs: 12, md: 6 }}>
                  <FormItem
                    label="Correo electrónico"
                    helperText={uiState.emailError}
                  >
                    <OutlinedInput
                      fullWidth
                      onChange={(e) => actions.onChangedEmail(e.target.value)}
                      value={uiState.email}
                      error={!!uiState.emailError}
                    />
                  </FormItem>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                  <FormItem
                    label="Contraseña"
                    helperText={uiState.passwordError}
                  >
                    <OutlinedInput
                      fullWidth
                      onChange={(e) =>
                        actions.onChangedPassword(e.target.value)
                      }
                      value={uiState.password}
                      error={!!uiState.passwordError}
                    />
                  </FormItem>
                </Grid>
              </Grid>
            }
          />
          <Button
            variant="contained"
            disabled={uiState.saveDisabled}
            onClick={actions.onClickedSave}
          >
            Guardar
          </Button>
        </Stack>
      </DialogContent>
    </>
  );
}
